// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Tabs Styling */

/* Analytics Tab */
.analytics-tab .analytics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-gap: 20px;
    gap: 20px;
    margin-top: 20px;
}

.analytics-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 30px;
    border-radius: 12px;
    text-align: center;
}

.kpi-grid .analytics-card {
    background: white;
    color: #0f172a;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
}

.kpi-grid .stat-large {
    color: #0f172a;
}

.kpi-grid .analytics-card h3 {
    color: #334155;
}

.analytics-card h3 {
    margin: 0 0 10px 0;
    font-size: 14px;
    opacity: 0.9;
}

.stat-large {
    font-size: 48px;
    font-weight: bold;
    margin: 10px 0;
}

/* Permissions Tab */
.permissions-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 20px;
    gap: 20px;
    margin-top: 20px;
}

.permission-card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    background: white;
}

.permission-card h4 {
    margin: 0 0 10px 0;
    color: #333;
}

.permission-card p {
    color: #666;
    font-size: 14px;
    margin-bottom: 15px;
}

.permission-actions {
    display: flex;
    gap: 10px;
}

/* Settings Tab */
.settings-sections {
    display: grid;
    grid-gap: 30px;
    gap: 30px;
    margin-top: 20px;
}

.setting-section {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    background: white;
}

.setting-section h3 {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 18px;
}

.setting-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #f0f0f0;
}

.setting-item:last-child {
    border-bottom: none;
}

.setting-item label {
    font-weight: 500;
    color: #555;
}

.setting-input {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 300px;
}

/* Toggle Switch */
.toggle-switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
}

.toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 24px;
}

.toggle-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
}

.toggle-switch input:checked+.toggle-slider {
    background-color: #f39c12;
}

.toggle-switch input:checked+.toggle-slider:before {
    transform: translateX(26px);
}

/* Database Tab */
.db-stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 20px;
    gap: 20px;
    margin: 20px 0;
}

.db-stat-card {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: white;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
}

.db-stat-card h3 {
    margin: 0 0 10px 0;
    font-size: 14px;
    opacity: 0.9;
}

.stat-value {
    font-size: 32px;
    font-weight: bold;
}

.db-tables-list {
    margin-top: 30px;
}

.db-tables-list h3 {
    margin-bottom: 15px;
}

.db-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 0 8px 12px 8px;
    flex-wrap: wrap;
}

.db-filter-group {
    display: flex;
    gap: 8px;
    align-items: center;
}

.db-maintenance {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

/* Security Tab */
.security-sections {
    display: grid;
    grid-gap: 20px;
    gap: 20px;
    margin-top: 20px;
}

.security-section {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    background: white;
}

.security-section h3 {
    margin: 0 0 15px 0;
    color: #333;
}

/* Activity Monitor Tab */
.activity-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 20px;
    gap: 20px;
    margin: 20px 0;
}

.activity-stat {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    color: white;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
}

.activity-stat h4 {
    margin: 0 0 10px 0;
    font-size: 14px;
    opacity: 0.9;
}

.live-badge {
    background: #ff4444;
    color: white;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: bold;
}

.activity-feed {
    margin-top: 20px;
}

.activity-feed h3 {
    margin-bottom: 15px;
}

.activity-group {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 12px;
    background: #fff;
}

.activity-group-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.badge {
    background: #eef2ff;
    color: #4338ca;
    padding: 4px 10px;
    border-radius: 999px;
    font-weight: 700;
    font-size: 12px;
}

.activity-item {
    display: flex;
    gap: 15px;
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
    align-items: flex-start;
}

.activity-icon {
    font-size: 24px;
}

.activity-content {
    flex: 1 1;
}

.activity-content p {
    margin: 0 0 5px 0;
    color: #333;
}

.activity-time {
    font-size: 12px;
    color: #999;
}

/* Reports Tab */
.reports-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    grid-gap: 20px;
    gap: 20px;
    margin-top: 20px;
}

.tab-subtitle {
    margin: 12px 20px 0 20px;
    color: #6b7280;
    font-size: 14px;
}

.search-input {
    padding: 8px 10px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    width: 220px;
}

.chart-placeholder {
    margin: 18px 20px 24px 20px;
    padding: 36px;
    border: 1px dashed #e2e8f0;
    border-radius: 8px;
    text-align: center;
    color: #9ca3af;
}

.chart-inner {
    font-style: italic;
}

.report-card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 25px;
    background: white;
    text-align: center;
}

.report-card h3 {
    margin: 0 0 10px 0;
    color: #333;
}

.report-card p {
    color: #666;
    font-size: 14px;
    margin-bottom: 20px;
}

/* Common Styles */
.data-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.data-table th,
.data-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
}

.data-table th {
    background: #f8f9fa;
    font-weight: 600;
    color: #333;
}

.data-table tr:hover {
    background: #f8f9fa;
}

.btn-small {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    background: #f39c12;
    color: white;
}

.btn-small.danger {
    background: #e74c3c;
}

.action-btn {
    padding: 6px 10px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 16px;
}

.action-btn:hover {
    background: #f0f0f0;
    border-radius: 4px;
}

.no-data {
    text-align: center;
    padding: 40px;
    color: #999;
}

.primary-btn {
    background: #f39c12;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
}

.primary-btn:hover {
    background: #e67e22;
}

.secondary-btn {
    background: #3498db;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
}

.secondary-btn:hover {
    background: #2980b9;
}

.export-btn {
    background: #27ae60;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
}

.export-btn:hover {
    background: #229954;
}

/* Payment Gateway Tab */
.payment-gateway-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    grid-gap: 20px;
    gap: 20px;
    margin-top: 25px;
}

.gateway-card {
    padding: 24px;
    background: white;
    border: 1px solid #edf2f7;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.gateway-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.gateway-layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 16px;
    gap: 16px;
    padding: 0 18px 18px 18px;
}

.gateway-status-card,
.gateway-form {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px;
    background: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
}

.status-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.gateway-chip {
    padding: 6px 12px;
    border-radius: 999px;
    font-weight: 700;
}

.gateway-chip.online {
    background: #ecfdf3;
    color: #0f9d58;
}

.gateway-chip.offline {
    background: #fef2f2;
    color: #b91c1c;
}

.meta-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    grid-gap: 12px;
    gap: 12px;
    margin-top: 12px;
}

.meta-grid label {
    font-size: 12px;
    color: #6b7280;
}

.meta-grid p {
    margin: 4px 0 0 0;
    color: #0f172a;
}

.env-pill {
    padding: 4px 10px;
    background: #eef2ff;
    color: #4338ca;
    border-radius: 12px;
    display: inline-block;
}

.small-mono {
    font-family: monospace;
    font-size: 12px;
    color: #475569;
}

.status-actions {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.test-chip {
    padding: 6px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 700;
}

.test-chip.success {
    background: #ecfdf3;
    color: #0f9d58;
}

.test-chip.failed {
    background: #fef2f2;
    color: #b91c1c;
}

.gateway-form .form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    grid-gap: 12px;
    gap: 12px;
}

.gateway-form .form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

/* API Management */
.api-metrics {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    grid-gap: 12px;
    gap: 12px;
    padding: 12px 18px;
}

.api-metric {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
}

.api-metric span {
    color: #64748b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.3px;
    text-transform: uppercase;
}

.api-metric strong {
    display: block;
    margin-top: 6px;
    font-size: 22px;
    color: #0f172a;
}

.api-rate-limit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 12px 18px;
    border-top: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
}

.rate-controls {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.api-webhooks {
    padding: 16px 18px 18px 18px;
}

.api-webhook-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px;
    background: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
}

.form-grid.two-col {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    grid-gap: 12px;
    gap: 12px;
}

.webhook-actions {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.small-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 12px;
    color: #475569;
}

.gateway-card h3 {
    margin: 0;
    font-size: 1.25rem;
    color: #1a202c;
}

.gateway-status {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    width: -webkit-fit-content;
    width: fit-content;
}

.gateway-status.online {
    background: #c6f6d5;
    color: #22543d;
}

.gateway-status.offline {
    background: #fed7d7;
    color: #822727;
}

.transaction-history {
    margin-top: 40px;
}

.transaction-history h3 {
    margin-bottom: 20px;
    color: #2d3748;
}

/* KYC Management Tab */
.kyc-stats-row {
    display: flex;
    gap: 20px;
    margin: 20px 0;
}

.kyc-stat {
    flex: 1 1;
    background: rgba(255, 255, 255, 0.05);
    padding: 24px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
}

.kyc-stat span {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.6);
    text-transform: uppercase;
    letter-spacing: 1px;
}

.kyc-stat h3 {
    font-size: 2.25rem;
    margin: 10px 0 0 0;
    color: #f39c12;
    font-weight: 700;
}

.status-badge.completed {
    background: rgba(39, 174, 96, 0.2);
    color: #2ecc71;
}

/* Leads Command Center */




.leads-insights-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 16px;
    gap: 16px;
    padding: 20px;
}

.mini-kpi {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.mini-kpi span {
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.mini-kpi strong {
    font-size: 28px;
    font-weight: 700;
    color: #0f172a;
    margin-top: 4px;
}

.mini-kpi small {
    font-size: 12px;
    color: #10b981;
    margin-top: 2px;
    font-weight: 600;
}

.mini-kpi.purple {
    border-left: 4px solid #7c3aed;
}

.mini-kpi.blue {
    border-left: 4px solid #0ea5e9;
}

.mini-kpi.green {
    border-left: 4px solid #10b981;
}

.mini-kpi.amber {
    border-left: 4px solid #f59e0b;
}

.leads-toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 16px 20px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    align-items: flex-end;
}

.search-stack,
.filter-stack {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.input-label {
    font-size: 12px;
    color: #6b7280;
    font-weight: 600;
    letter-spacing: 0.2px;
}

.filter-select {
    padding: 10px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    font-size: 0.95rem;
    background: #fff;
}

.pill-filters {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 20px;
    background: #fff;
    border-bottom: 1px solid #f1f5f9;
}

.pill {
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #334155;
    padding: 8px 12px;
    border-radius: 999px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.pill.active {
    background: #0ea5e9;
    color: #fff;
    border-color: #0ea5e9;
}

.status-pill {
    display: inline-flex;
    align-items: center;
    padding: 6px 10px;
    border-radius: 999px;
    font-weight: 700;
    font-size: 0.85rem;
    text-transform: capitalize;
}

.status-pill.status-new {
    background: #eef2ff;
    color: #4f46e5;
}

.status-pill.status-contacted {
    background: #fff7ed;
    color: #ea580c;
}

.status-pill.status-qualified {
    background: #ecfeff;
    color: #0ea5e9;
}

.status-pill.status-converted {
    background: #ecfdf3;
    color: #16a34a;
}

.status-pill.status-lost {
    background: #f8fafc;
    color: #475569;
}

.lead-name {
    font-weight: 700;
    color: #0f172a;
}

.lead-id {
    color: #94a3b8;
    font-size: 12px;
}

.contact-line {
    color: #0f172a;
}

.contact-line.light {
    color: #94a3b8;
    font-size: 12px;
}

.action-buttons.tight {
    gap: 6px;
}

.inline-select {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 6px 8px;
    background: #fff;
    font-size: 0.85rem;
}

.action-btn.assign {
    color: #0ea5e9;
    font-weight: 700;
}

.status-badge.pending {
    background: rgba(243, 156, 18, 0.2);
    color: #f1c40f;
}

.status-badge.in-progress {
    background: rgba(52, 152, 219, 0.2);
    color: #3498db;
}

.status-badge.rejected {
    background: rgba(231, 76, 60, 0.2);
    color: #e74c3c;
}

.action-btn.view {
    color: #3498db !important;
}

.action-btn.edit {
    color: #2ecc71 !important;
}

.action-btn.delete {
    color: #e74c3c !important;
}

.header-title-group h2 {
    margin-bottom: 4px;
}

.tab-subtitle {
    margin: 0 !important;
    color: rgba(255, 255, 255, 0.5) !important;
    font-size: 0.9rem !important;
}

.pill-switch {
    display: inline-flex;
    background: rgba(15, 23, 42, 0.4);
    border: 1px solid rgba(148, 163, 184, 0.3);
    border-radius: 999px;
    padding: 4px;
    margin-right: 10px;
    gap: 4px;
}

.pill-btn {
    background: transparent;
    color: #e2e8f0;
    border: none;
    padding: 6px 14px;
    border-radius: 999px;
    font-weight: 600;
    cursor: pointer;
    font-size: 0.85rem;
    transition: all 0.2s ease;
}

.pill-btn.active {
    background: #fff;
    color: #0f172a;
    box-shadow: 0 6px 12px rgba(15, 23, 42, 0.2);
}

.mandate-substatus {
    display: inline-block;
    margin-left: 8px;
    font-size: 0.78rem;
    color: #64748b;
}

/* Admin Modals */
.admin-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px);
    animation: fadeIn 0.3s ease;
}

.admin-modal-content {
    background: #ffffff;
    width: 90%;
    max-width: 550px;
    padding: 40px;
    border-radius: 20px;
    color: #1e293b;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    position: relative;
    animation: slideUp 0.3s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUp {
    from {
        transform: translateY(20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.admin-modal-content h3 {
    margin: 0 0 24px 0;
    font-size: 24px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.5px;
}

.modal-form-group {
    margin-bottom: 24px;
}

.modal-form-group label {
    display: block;
    margin-bottom: 10px;
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.modal-input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #f1f5f9;
    background: #f8fafc;
    border-radius: 12px;
    font-size: 15px;
    transition: all 0.2s ease;
    outline: none;
}

.modal-input:focus {
    border-color: #f39c12;
    background: #fff;
    box-shadow: 0 0 0 4px rgba(243, 156, 18, 0.1);
}

textarea.modal-input {
    min-height: 100px;
    resize: vertical;
}

.admin-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: 40px;
}

.admin-modal-btn {
    padding: 12px 24px;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.2s ease;
    font-size: 15px;
}

.admin-modal-btn:active {
    transform: scale(0.98);
}

.admin-modal-btn.cancel {
    background: #f1f5f9;
    color: #64748b;
}

.admin-modal-btn.cancel:hover {
    background: #e2e8f0;
    color: #475569;
}

.admin-modal-btn.confirm {
    background: linear-gradient(135deg, #f39c12 0%, #d35400 100%);
    color: white;
    box-shadow: 0 4px 6px -1px rgba(243, 156, 18, 0.2);
}

.admin-modal-btn.confirm:hover {
    transform: translateY(-1px);
    box-shadow: 0 10px 15px -3px rgba(243, 156, 18, 0.3);
}

/* Mandate Modal */
.mandate-modal {
    max-width: 900px;
    padding: 32px 36px;
    max-height: 85vh;
    overflow-y: auto;
}

.mandate-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f1f5f9;
    padding-bottom: 16px;
}

.mandate-header h3 {
    margin: 0;
}

.mandate-header p {
    margin: 6px 0 0;
    color: #64748b;
    font-size: 0.9rem;
}

.mandate-section {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 18px 20px;
    margin-bottom: 16px;
}

.mandate-status-bar {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 16px;
    border-radius: 12px;
    background: #fff7ed;
    border: 1px solid #fed7aa;
    color: #7c2d12;
    margin-bottom: 16px;
    font-weight: 600;
}

.mandate-details {
    background: #0f172a;
    color: #e2e8f0;
    border-radius: 14px;
    padding: 16px;
    margin-bottom: 16px;
    max-height: 240px;
    overflow: auto;
}

.mandate-details h4 {
    margin: 0 0 10px 0;
    font-size: 0.9rem;
    color: #f8fafc;
}

.mandate-details pre {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 0.8rem;
}

.mandate-section h4 {
    margin: 0 0 12px 0;
    font-size: 0.95rem;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #475569;
}

.bank-filter-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.bank-toggle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    color: #475569;
}

.bank-select-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.mandate-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: 14px 18px;
    gap: 14px 18px;
}

.mandate-modal .admin-form-group {
    margin-bottom: 0;
}

.mandate-modal .admin-form-group label {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #64748b;
    font-weight: 600;
    margin-bottom: 8px;
}

.mandate-modal .admin-form-input,
.mandate-modal .admin-form-select {
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: #fff;
    padding: 10px 12px;
    font-size: 0.95rem;
    width: 100%;
}

.mandate-modal .admin-form-input:focus,
.mandate-modal .admin-form-select:focus {
    outline: none;
    border-color: #f39c12;
    box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.15);
}

.mandate-message {
    margin: 6px 0 0;
    color: #065f46;
    font-weight: 600;
}

.mandate-error-chip {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    padding: 4px 8px;
    border-radius: 999px;
    background: #fee2e2;
    color: #991b1b;
    font-size: 0.72rem;
    font-weight: 700;
    border: 1px solid #fecaca;
}

.mandate-error-panel {
    background: #fee2e2;
    color: #7f1d1d;
    border: 1px solid #fecaca;
    padding: 10px 12px;
    border-radius: 12px;
    margin-bottom: 16px;
    font-weight: 600;
}

@media (max-width: 900px) {
    .mandate-grid {
        grid-template-columns: 1fr;
    }

    .mandate-modal {
        max-width: 640px;
        padding: 24px;
    }
}

.permissions-checklist::-webkit-scrollbar {
    width: 6px;
}

.permissions-checklist::-webkit-scrollbar-track {
    background: #f1f5f9;
}

.permissions-checklist::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
}

.permissions-checklist::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}

/* Delete Confirmation Modal Styles */
.delete-confirmation-modal {
    max-width: 500px !important;
}

.delete-modal-header {
    text-align: center;
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 2px solid #fee2e2;
}

.delete-modal-header .warning-icon {
    font-size: 48px;
    margin-bottom: 12px;
    animation: pulse 2s infinite;
}

@keyframes pulse {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.1);
    }
}

.delete-modal-header h3 {
    color: #dc2626;
    font-size: 22px;
    font-weight: 700;
    margin: 0;
}

.delete-modal-body {
    margin-bottom: 24px;
}

.warning-text {
    text-align: center;
    font-size: 15px;
    color: #374151;
    margin-bottom: 24px;
    line-height: 1.6;
}

.warning-text strong {
    color: #dc2626;
    font-weight: 700;
}

.loan-info-box {
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    border-left: 4px solid #f59e0b;
    padding: 16px 20px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.loan-info-box h4 {
    margin: 0 0 12px 0;
    color: #92400e;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.loan-info-box p {
    margin: 6px 0;
    color: #78350f;
    font-size: 14px;
}

.loan-info-box strong {
    color: #92400e;
    font-weight: 600;
}

.warning-box {
    background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
    border-left: 4px solid #dc2626;
    padding: 16px 20px;
    border-radius: 8px;
}

.warning-title {
    margin: 0 0 12px 0;
    color: #991b1b;
    font-size: 14px;
    font-weight: 700;
}

.warning-list {
    margin: 12px 0;
    padding-left: 24px;
    color: #7f1d1d;
}

.warning-list li {
    margin: 6px 0;
    font-size: 13px;
    line-height: 1.5;
}

.danger-text {
    margin: 12px 0 0 0;
    color: #991b1b;
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    padding-top: 12px;
    border-top: 1px solid #fca5a5;
}

.admin-modal-btn.delete-confirm {
    background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
    color: white;
    box-shadow: 0 4px 6px -1px rgba(220, 38, 38, 0.3);
    font-weight: 700;
}

.admin-modal-btn.delete-confirm:hover {
    background: linear-gradient(135deg, #b91c1c 0%, #7f1d1d 100%);
    transform: translateY(-1px);
    box-shadow: 0 10px 15px -3px rgba(220, 38, 38, 0.4);
}

.admin-modal-btn.delete-confirm:active {
    transform: scale(0.98);
}




.kanban-cards {
    overflow-y: auto;
    gap: 10px;
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
    flex: 1 1;
}

.kanban-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: grab;
}

.kanban-card:active {
    cursor: grabbing;
}

.kanban-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border-color: #cbd5e1;
}

.k-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
}

.k-name {
    font-weight: 600;
    color: #0f172a;
    font-size: 14px;
}

.k-date {
    font-size: 10px;
    color: #94a3b8;
}

.k-details {
    font-size: 12px;
    color: #64748b;
    margin-bottom: 10px;
    line-height: 1.5;
}

.k-source {
    display: inline-block;
    font-size: 10px;
    background: #f1f5f9;
    padding: 2px 6px;
    border-radius: 4px;
    color: #475569;
}



.leads-modal-header {
    background: linear-gradient(to right, #f8fafc, #fff);
    padding: 24px;
    border-bottom: 1px solid #e2e8f0;
}

.leads-modal-header h3 {
    margin: 0;
    color: #0f172a;
    font-size: 20px;
    font-weight: 700;
}

.leads-modal-body {
    padding: 24px;
}

.modal-grid-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 16px;
    gap: 16px;
    margin-bottom: 16px;
}

.fancy-input-group {
    position: relative;
    margin-bottom: 6px;
}

.fancy-input,
.fancy-select,
.fancy-textarea {
    width: 100%;
    padding: 12px 14px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.2s;
    background: #ffffff;
    box-sizing: border-box;
    /* Important fix */
}

.fancy-input:focus,
.fancy-select:focus,
.fancy-textarea:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    outline: none;
}

.fancy-label {
    display: block;
    margin-bottom: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.modal-footer {
    padding: 20px 24px;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

/* -----------------------------------------------------------------------------
   LEADS DASHBOARD RESTRUCTURE - FINAL POLISH
   ----------------------------------------------------------------------------- */

/* Main Container */
.leads-dashboard-container {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 80px);
    /* Adjust based on your header height */
    background: #f8fafc;
    overflow: hidden;
}

/* 1. Header & Stats Section */
.leads-header-section {
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    padding: 2px 0;
    flex-shrink: 0;
    padding: 2px 0;
    flex-shrink: 0;
    z-index: 20;
    position: relative;
}

.leads-insights-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 16px;
    gap: 16px;
    padding: 16px 24px;
    max-width: 1600px;
    margin: 0 auto;
}

.mini-kpi {
    background: #ffffff;
    border: 1px solid #f1f5f9;
    border-radius: 10px;
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    position: relative;
    overflow: hidden;
    min-height: 120px;
    padding: 20px;
}

.kpi-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.kpi-header span:first-child {
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.kpi-trend {
    font-size: 12px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 12px;
    background: #f1f5f9;
    color: #64748b;
}

.kpi-trend.up {
    background: #dcfce7;
    color: #16a34a;
}

.kpi-alert {
    font-size: 11px;
    font-weight: 700;
    color: #ef4444;
    background: #fee2e2;
    padding: 2px 6px;
    border-radius: 4px;
}

.kpi-body {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.kpi-body strong {
    font-size: 28px;
    font-weight: 700;
    color: #1e293b;
    line-height: 1;
}

.kpi-chart {
    flex-grow: 1;
    max-width: 100px;
    height: 40px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
}

.kpi-chart.donut svg {
    transform: rotate(-90deg);
}

.kpi-chart.bars {
    display: flex;
    gap: 4px;
    align-items: flex-end;
    height: 32px;
}

.kpi-chart.bars .bar {
    width: 6px;
    background: #e2e8f0;
    border-radius: 2px;
    transition: height 0.3s ease;
}

.kpi-chart.bars .bar.active {
    background: #10b981;
}

.kpi-icon-bg {
    color: #f59e0b;
    opacity: 0.8;
}

.mini-kpi::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
}

.mini-kpi.purple::after {
    background: #8b5cf6;
}

.mini-kpi.blue::after {
    background: #3b82f6;
}

.mini-kpi.green::after {
    background: #10b981;
}

.mini-kpi.amber::after {
    background: #f59e0b;
}

.mini-kpi span {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    margin-bottom: 6px;
}

.mini-kpi strong {
    font-size: 28px;
    font-weight: 800;
    color: #1e293b;
    line-height: 1.1;
}

/* 2. Controls Toolbar */
.leads-toolbar {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-gap: 20px;
    gap: 20px;
    align-items: center;
    padding: 12px 24px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    position: relative;
    z-index: 15;
}

button {
    cursor: pointer;
}

.search-stack {
    flex: 1 1;
    max-width: 400px;
    position: relative;
}

.search-input {
    width: 100%;
    padding: 0 16px 0 36px;
    height: 40px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #f8fafc;
    font-size: 14px;
    transition: all 0.2s;
}

.search-input:focus {
    background: #fff;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-icon-placeholder {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    pointer-events: none;
}

.filter-group {
    display: flex;
    gap: 10px;
}

.filter-select {
    height: 40px;
    padding: 0 32px 0 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background-color: #ffffff;
    font-size: 13px;
    color: #334155;
    font-weight: 500;
    cursor: pointer;
}

.filter-select:hover {
    border-color: #cbd5e1;
}

.view-toggle-group {
    display: flex;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 8px;
}

.view-btn {
    padding: 6px 12px;
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    background: transparent;
    border: none;
    cursor: pointer;
    border-radius: 6px;
}

.view-btn.active {
    background: #fff;
    color: #0f172a;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* 3. Quick Pills Row */
.pill-filters {
    display: flex;
    gap: 8px;
    padding: 12px 24px;
    background: #fff;
    border-bottom: 1px solid #e2e8f0;
    overflow-x: auto;
    flex-shrink: 0;
    /* Prevent shrinking */
}

.pill {
    padding: 6px 14px;
    border-radius: 99px;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    transition: all 0.15s;
    white-space: nowrap;
}

.pill:hover {
    background: #f1f5f9;
    color: #1e293b;
}

.pill.active {
    background: #eff6ff;
    color: #2563eb;
    border-color: #bfdbfe;
}

/* 4. Kanban Board Area */
.kanban-board-container {
    flex: 1 1;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 24px;
    background: #f8fafc;
}

.kanban-board {
    display: flex;
    gap: 20px;
    height: 100%;
    align-items: flex-start;
}

.kanban-column {
    min-width: 280px;
    width: 280px;
    max-width: 280px;
    background: #eff1f5;
    /* Subtle contrast */
    border-radius: 12px;
    padding: 6px;
    /* Tighter padding */
    display: flex;
    flex-direction: column;
    max-height: 100%;
    border: 1px solid #e2e8f0;
}

.kanban-header {
    padding: 12px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-weight: 700;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.kanban-count {
    background: rgba(0, 0, 0, 0.05);
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    color: #64748b;
}

.kanban-cards {
    flex: 1 1;
    overflow-y: auto;
    padding: 0 4px 4px 4px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* Custom Scrollbar for columns */
.kanban-cards::-webkit-scrollbar {
    width: 4px;
}

.kanban-cards::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

.kanban-card {
    background: #fff;
    border-radius: 8px;
    padding: 14px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    border: 1px solid transparent;
    transition: all 0.2s;
    cursor: grab;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.kanban-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.08);
    /* Better lift */
    border-color: #cbd5e1;
    z-index: 5;
}

.k-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.k-name {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
    line-height: 1.3;
}

.k-date {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 500;
}

.k-source {
    align-self: flex-start;
    font-size: 10px;
    font-weight: 600;
    color: #64748b;
    background: #f1f5f9;
    padding: 3px 8px;
    border-radius: 4px;
    border: 1px solid #e2e8f0;
}

.k-details {
    font-size: 12px;
    color: #475569;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.k-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
    border-top: 1px solid #f1f5f9;
    margin-top: 2px;
}

.k-assignee {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 500;
    color: #64748b;
}

.icon-btn {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    border: 1px solid transparent;
    background: transparent;
    color: #94a3b8;
    transition: all 0.15s;
    cursor: pointer;
}

.icon-btn:hover {
    background: #f1f5f9;
    color: #0f172a;
}

.icon-btn.whatsapp:hover {
    color: #16a34a;
    background: #dcfce7;
}

.icon-btn.call:hover {
    color: #0284c7;
    background: #e0f2fe;
}

.icon-btn.edit:hover {
    color: #f59e0b;
    background: #fef3c7;
}

.icon-btn.assign:hover {
    color: #6366f1;
    background: #e0e7ff;
}

.icon-btn.delete:hover {
    color: #ef4444;
    background: #fee2e2;
}

/* 5. Modal Polish */
.leads-modal-header {
    background: #ffffff;
    padding: 20px 24px;
    border-bottom: 1px solid #f1f5f9;
}

.leads-modal-header h3 {
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
}

.leads-modal-body {
    padding: 24px;
    background: #fcfcfc;
}

.modal-grid-row {
    gap: 20px;
    margin-bottom: 20px;
}

.fancy-label {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
}

.fancy-input,
.fancy-select,
.fancy-textarea {
    border: 1px solid #e2e8f0;
    background: #fff;
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}

.fancy-input:focus,
.fancy-select:focus,
.fancy-textarea:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    outline: none;
}

.modal-footer {
    padding: 20px 24px;
    background: #a85757;
    border-top: 1px solid #f1f5f9;
}

/* -----------------------------------------------------------------------------
   LEADS MODAL OVERLAY STYLES
   ----------------------------------------------------------------------------- */

.leads-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(15, 23, 42, 0.6);
    -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.leads-modal-content {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    animation: modalSlideUp 0.3s ease-out forwards;
}

@keyframes modalSlideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminTabs.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,kBAAkB;AAClB;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,4DAA4D;IAC5D,cAAS;IAAT,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,cAAS;IAAT,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,cAAS;IAAT,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,4DAA4D;IAC5D,cAAS;IAAT,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,4DAA4D;IAC5D,cAAS;IAAT,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAS;IAAT,SAAS;IACT,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,+GAA+G;IAC/G,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,0BAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,mCAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA,yBAAyB;;;;;AAKzB;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAS;IAAT,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,0CAA0C;IAC1C,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;IACpB,iCAAiC;IACjC,0CAA0C;IAC1C,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kCAA0B;YAA1B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,iDAAiD;IACjD,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,kDAAkD;AACtD;;AAEA;IACI,2BAA2B;IAC3B,oDAAoD;AACxD;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,mBAAc;IAAd,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;QAChB,aAAa;IACjB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,mDAAmD;AACvD;;AAEA;IACI,sBAAsB;AAC1B;;;;;AAKA;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yCAAyC;IACzC,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;;;AAIA;IACI,oDAAoD;IACpD,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAS;IAAT,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;;IAGI,qBAAqB;IACrB,6CAA6C;IAC7C,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;;kFAEkF;;AAElF,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,uCAAuC;IACvC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;IACd,cAAc;IACd,cAAc;IACd,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAS;IAAT,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,oCAAoC;IACpC,cAAS;IAAT,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,yCAAyC;AAC7C;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,iCAAiC;AACjC;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,yCAAyC;IACzC,6BAA6B;IAC7B,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;IAC/C,gBAAgB;IAChB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;;IAGI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yCAAyC;AAC7C;;AAEA;;;IAGI,qBAAqB;IACrB,6CAA6C;IAC7C,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;;kFAEkF;;AAElF;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,kCAA0B;YAA1B,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,qFAAqF;IACrF,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ","sourcesContent":["/* Admin Tabs Styling */\n\n/* Analytics Tab */\n.analytics-tab .analytics-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.analytics-card {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    padding: 30px;\n    border-radius: 12px;\n    text-align: center;\n}\n\n.kpi-grid .analytics-card {\n    background: white;\n    color: #0f172a;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);\n}\n\n.kpi-grid .stat-large {\n    color: #0f172a;\n}\n\n.kpi-grid .analytics-card h3 {\n    color: #334155;\n}\n\n.analytics-card h3 {\n    margin: 0 0 10px 0;\n    font-size: 14px;\n    opacity: 0.9;\n}\n\n.stat-large {\n    font-size: 48px;\n    font-weight: bold;\n    margin: 10px 0;\n}\n\n/* Permissions Tab */\n.permissions-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.permission-card {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 20px;\n    background: white;\n}\n\n.permission-card h4 {\n    margin: 0 0 10px 0;\n    color: #333;\n}\n\n.permission-card p {\n    color: #666;\n    font-size: 14px;\n    margin-bottom: 15px;\n}\n\n.permission-actions {\n    display: flex;\n    gap: 10px;\n}\n\n/* Settings Tab */\n.settings-sections {\n    display: grid;\n    gap: 30px;\n    margin-top: 20px;\n}\n\n.setting-section {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 20px;\n    background: white;\n}\n\n.setting-section h3 {\n    margin: 0 0 20px 0;\n    color: #333;\n    font-size: 18px;\n}\n\n.setting-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 0;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.setting-item:last-child {\n    border-bottom: none;\n}\n\n.setting-item label {\n    font-weight: 500;\n    color: #555;\n}\n\n.setting-input {\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    width: 300px;\n}\n\n/* Toggle Switch */\n.toggle-switch {\n    position: relative;\n    display: inline-block;\n    width: 50px;\n    height: 24px;\n}\n\n.toggle-switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.toggle-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    transition: 0.4s;\n    border-radius: 24px;\n}\n\n.toggle-slider:before {\n    position: absolute;\n    content: \"\";\n    height: 18px;\n    width: 18px;\n    left: 3px;\n    bottom: 3px;\n    background-color: white;\n    transition: 0.4s;\n    border-radius: 50%;\n}\n\n.toggle-switch input:checked+.toggle-slider {\n    background-color: #f39c12;\n}\n\n.toggle-switch input:checked+.toggle-slider:before {\n    transform: translateX(26px);\n}\n\n/* Database Tab */\n.db-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 20px;\n    margin: 20px 0;\n}\n\n.db-stat-card {\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n    color: white;\n    padding: 20px;\n    border-radius: 8px;\n    text-align: center;\n}\n\n.db-stat-card h3 {\n    margin: 0 0 10px 0;\n    font-size: 14px;\n    opacity: 0.9;\n}\n\n.stat-value {\n    font-size: 32px;\n    font-weight: bold;\n}\n\n.db-tables-list {\n    margin-top: 30px;\n}\n\n.db-tables-list h3 {\n    margin-bottom: 15px;\n}\n\n.db-controls {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 0 8px 12px 8px;\n    flex-wrap: wrap;\n}\n\n.db-filter-group {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.db-maintenance {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n/* Security Tab */\n.security-sections {\n    display: grid;\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.security-section {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 20px;\n    background: white;\n}\n\n.security-section h3 {\n    margin: 0 0 15px 0;\n    color: #333;\n}\n\n/* Activity Monitor Tab */\n.activity-stats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 20px;\n    margin: 20px 0;\n}\n\n.activity-stat {\n    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n    color: white;\n    padding: 20px;\n    border-radius: 8px;\n    text-align: center;\n}\n\n.activity-stat h4 {\n    margin: 0 0 10px 0;\n    font-size: 14px;\n    opacity: 0.9;\n}\n\n.live-badge {\n    background: #ff4444;\n    color: white;\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.activity-feed {\n    margin-top: 20px;\n}\n\n.activity-feed h3 {\n    margin-bottom: 15px;\n}\n\n.activity-group {\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    padding: 12px;\n    margin-bottom: 12px;\n    background: #fff;\n}\n\n.activity-group-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.badge {\n    background: #eef2ff;\n    color: #4338ca;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-weight: 700;\n    font-size: 12px;\n}\n\n.activity-item {\n    display: flex;\n    gap: 15px;\n    padding: 15px;\n    border-bottom: 1px solid #f0f0f0;\n    align-items: flex-start;\n}\n\n.activity-icon {\n    font-size: 24px;\n}\n\n.activity-content {\n    flex: 1;\n}\n\n.activity-content p {\n    margin: 0 0 5px 0;\n    color: #333;\n}\n\n.activity-time {\n    font-size: 12px;\n    color: #999;\n}\n\n/* Reports Tab */\n.reports-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.tab-subtitle {\n    margin: 12px 20px 0 20px;\n    color: #6b7280;\n    font-size: 14px;\n}\n\n.search-input {\n    padding: 8px 10px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    width: 220px;\n}\n\n.chart-placeholder {\n    margin: 18px 20px 24px 20px;\n    padding: 36px;\n    border: 1px dashed #e2e8f0;\n    border-radius: 8px;\n    text-align: center;\n    color: #9ca3af;\n}\n\n.chart-inner {\n    font-style: italic;\n}\n\n.report-card {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 25px;\n    background: white;\n    text-align: center;\n}\n\n.report-card h3 {\n    margin: 0 0 10px 0;\n    color: #333;\n}\n\n.report-card p {\n    color: #666;\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n\n/* Common Styles */\n.data-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\n\n.data-table th,\n.data-table td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.data-table th {\n    background: #f8f9fa;\n    font-weight: 600;\n    color: #333;\n}\n\n.data-table tr:hover {\n    background: #f8f9fa;\n}\n\n.btn-small {\n    padding: 6px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    background: #f39c12;\n    color: white;\n}\n\n.btn-small.danger {\n    background: #e74c3c;\n}\n\n.action-btn {\n    padding: 6px 10px;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n.action-btn:hover {\n    background: #f0f0f0;\n    border-radius: 4px;\n}\n\n.no-data {\n    text-align: center;\n    padding: 40px;\n    color: #999;\n}\n\n.primary-btn {\n    background: #f39c12;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 500;\n}\n\n.primary-btn:hover {\n    background: #e67e22;\n}\n\n.secondary-btn {\n    background: #3498db;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 500;\n}\n\n.secondary-btn:hover {\n    background: #2980b9;\n}\n\n.export-btn {\n    background: #27ae60;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 500;\n}\n\n.export-btn:hover {\n    background: #229954;\n}\n\n/* Payment Gateway Tab */\n.payment-gateway-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 20px;\n    margin-top: 25px;\n}\n\n.gateway-card {\n    padding: 24px;\n    background: white;\n    border: 1px solid #edf2f7;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\n.gateway-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.gateway-layout {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    padding: 0 18px 18px 18px;\n}\n\n.gateway-status-card,\n.gateway-form {\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 16px;\n    background: #fff;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);\n}\n\n.status-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.gateway-chip {\n    padding: 6px 12px;\n    border-radius: 999px;\n    font-weight: 700;\n}\n\n.gateway-chip.online {\n    background: #ecfdf3;\n    color: #0f9d58;\n}\n\n.gateway-chip.offline {\n    background: #fef2f2;\n    color: #b91c1c;\n}\n\n.meta-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 12px;\n    margin-top: 12px;\n}\n\n.meta-grid label {\n    font-size: 12px;\n    color: #6b7280;\n}\n\n.meta-grid p {\n    margin: 4px 0 0 0;\n    color: #0f172a;\n}\n\n.env-pill {\n    padding: 4px 10px;\n    background: #eef2ff;\n    color: #4338ca;\n    border-radius: 12px;\n    display: inline-block;\n}\n\n.small-mono {\n    font-family: monospace;\n    font-size: 12px;\n    color: #475569;\n}\n\n.status-actions {\n    margin-top: 12px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.test-chip {\n    padding: 6px 10px;\n    border-radius: 10px;\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.test-chip.success {\n    background: #ecfdf3;\n    color: #0f9d58;\n}\n\n.test-chip.failed {\n    background: #fef2f2;\n    color: #b91c1c;\n}\n\n.gateway-form .form-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 12px;\n}\n\n.gateway-form .form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n/* API Management */\n.api-metrics {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n    gap: 12px;\n    padding: 12px 18px;\n}\n\n.api-metric {\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 12px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);\n}\n\n.api-metric span {\n    color: #64748b;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.3px;\n    text-transform: uppercase;\n}\n\n.api-metric strong {\n    display: block;\n    margin-top: 6px;\n    font-size: 22px;\n    color: #0f172a;\n}\n\n.api-rate-limit {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 14px;\n    padding: 12px 18px;\n    border-top: 1px solid #e2e8f0;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.rate-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.api-webhooks {\n    padding: 16px 18px 18px 18px;\n}\n\n.api-webhook-card {\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 14px;\n    background: #fff;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);\n}\n\n.form-grid.two-col {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 12px;\n}\n\n.webhook-actions {\n    margin-top: 12px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.small-mono {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    font-size: 12px;\n    color: #475569;\n}\n\n.gateway-card h3 {\n    margin: 0;\n    font-size: 1.25rem;\n    color: #1a202c;\n}\n\n.gateway-status {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 9999px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    width: fit-content;\n}\n\n.gateway-status.online {\n    background: #c6f6d5;\n    color: #22543d;\n}\n\n.gateway-status.offline {\n    background: #fed7d7;\n    color: #822727;\n}\n\n.transaction-history {\n    margin-top: 40px;\n}\n\n.transaction-history h3 {\n    margin-bottom: 20px;\n    color: #2d3748;\n}\n\n/* KYC Management Tab */\n.kyc-stats-row {\n    display: flex;\n    gap: 20px;\n    margin: 20px 0;\n}\n\n.kyc-stat {\n    flex: 1;\n    background: rgba(255, 255, 255, 0.05);\n    padding: 24px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    text-align: center;\n    backdrop-filter: blur(10px);\n}\n\n.kyc-stat span {\n    font-size: 0.85rem;\n    color: rgba(255, 255, 255, 0.6);\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.kyc-stat h3 {\n    font-size: 2.25rem;\n    margin: 10px 0 0 0;\n    color: #f39c12;\n    font-weight: 700;\n}\n\n.status-badge.completed {\n    background: rgba(39, 174, 96, 0.2);\n    color: #2ecc71;\n}\n\n/* Leads Command Center */\n\n\n\n\n.leads-insights-row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n    padding: 20px;\n}\n\n.mini-kpi {\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.mini-kpi span {\n    font-size: 13px;\n    color: #64748b;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.mini-kpi strong {\n    font-size: 28px;\n    font-weight: 700;\n    color: #0f172a;\n    margin-top: 4px;\n}\n\n.mini-kpi small {\n    font-size: 12px;\n    color: #10b981;\n    margin-top: 2px;\n    font-weight: 600;\n}\n\n.mini-kpi.purple {\n    border-left: 4px solid #7c3aed;\n}\n\n.mini-kpi.blue {\n    border-left: 4px solid #0ea5e9;\n}\n\n.mini-kpi.green {\n    border-left: 4px solid #10b981;\n}\n\n.mini-kpi.amber {\n    border-left: 4px solid #f59e0b;\n}\n\n.leads-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    padding: 16px 20px;\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n    align-items: flex-end;\n}\n\n.search-stack,\n.filter-stack {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.input-label {\n    font-size: 12px;\n    color: #6b7280;\n    font-weight: 600;\n    letter-spacing: 0.2px;\n}\n\n.filter-select {\n    padding: 10px 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    font-size: 0.95rem;\n    background: #fff;\n}\n\n.pill-filters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 16px 20px;\n    background: #fff;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.pill {\n    border: 1px solid #e2e8f0;\n    background: #fff;\n    color: #334155;\n    padding: 8px 12px;\n    border-radius: 999px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.pill.active {\n    background: #0ea5e9;\n    color: #fff;\n    border-color: #0ea5e9;\n}\n\n.status-pill {\n    display: inline-flex;\n    align-items: center;\n    padding: 6px 10px;\n    border-radius: 999px;\n    font-weight: 700;\n    font-size: 0.85rem;\n    text-transform: capitalize;\n}\n\n.status-pill.status-new {\n    background: #eef2ff;\n    color: #4f46e5;\n}\n\n.status-pill.status-contacted {\n    background: #fff7ed;\n    color: #ea580c;\n}\n\n.status-pill.status-qualified {\n    background: #ecfeff;\n    color: #0ea5e9;\n}\n\n.status-pill.status-converted {\n    background: #ecfdf3;\n    color: #16a34a;\n}\n\n.status-pill.status-lost {\n    background: #f8fafc;\n    color: #475569;\n}\n\n.lead-name {\n    font-weight: 700;\n    color: #0f172a;\n}\n\n.lead-id {\n    color: #94a3b8;\n    font-size: 12px;\n}\n\n.contact-line {\n    color: #0f172a;\n}\n\n.contact-line.light {\n    color: #94a3b8;\n    font-size: 12px;\n}\n\n.action-buttons.tight {\n    gap: 6px;\n}\n\n.inline-select {\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 6px 8px;\n    background: #fff;\n    font-size: 0.85rem;\n}\n\n.action-btn.assign {\n    color: #0ea5e9;\n    font-weight: 700;\n}\n\n.status-badge.pending {\n    background: rgba(243, 156, 18, 0.2);\n    color: #f1c40f;\n}\n\n.status-badge.in-progress {\n    background: rgba(52, 152, 219, 0.2);\n    color: #3498db;\n}\n\n.status-badge.rejected {\n    background: rgba(231, 76, 60, 0.2);\n    color: #e74c3c;\n}\n\n.action-btn.view {\n    color: #3498db !important;\n}\n\n.action-btn.edit {\n    color: #2ecc71 !important;\n}\n\n.action-btn.delete {\n    color: #e74c3c !important;\n}\n\n.header-title-group h2 {\n    margin-bottom: 4px;\n}\n\n.tab-subtitle {\n    margin: 0 !important;\n    color: rgba(255, 255, 255, 0.5) !important;\n    font-size: 0.9rem !important;\n}\n\n.pill-switch {\n    display: inline-flex;\n    background: rgba(15, 23, 42, 0.4);\n    border: 1px solid rgba(148, 163, 184, 0.3);\n    border-radius: 999px;\n    padding: 4px;\n    margin-right: 10px;\n    gap: 4px;\n}\n\n.pill-btn {\n    background: transparent;\n    color: #e2e8f0;\n    border: none;\n    padding: 6px 14px;\n    border-radius: 999px;\n    font-weight: 600;\n    cursor: pointer;\n    font-size: 0.85rem;\n    transition: all 0.2s ease;\n}\n\n.pill-btn.active {\n    background: #fff;\n    color: #0f172a;\n    box-shadow: 0 6px 12px rgba(15, 23, 42, 0.2);\n}\n\n.mandate-substatus {\n    display: inline-block;\n    margin-left: 8px;\n    font-size: 0.78rem;\n    color: #64748b;\n}\n\n/* Admin Modals */\n.admin-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.85);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    backdrop-filter: blur(8px);\n    animation: fadeIn 0.3s ease;\n}\n\n.admin-modal-content {\n    background: #ffffff;\n    width: 90%;\n    max-width: 550px;\n    padding: 40px;\n    border-radius: 20px;\n    color: #1e293b;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n    position: relative;\n    animation: slideUp 0.3s ease;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes slideUp {\n    from {\n        transform: translateY(20px);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.admin-modal-content h3 {\n    margin: 0 0 24px 0;\n    font-size: 24px;\n    font-weight: 700;\n    color: #0f172a;\n    letter-spacing: -0.5px;\n}\n\n.modal-form-group {\n    margin-bottom: 24px;\n}\n\n.modal-form-group label {\n    display: block;\n    margin-bottom: 10px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.modal-input {\n    width: 100%;\n    padding: 12px 16px;\n    border: 2px solid #f1f5f9;\n    background: #f8fafc;\n    border-radius: 12px;\n    font-size: 15px;\n    transition: all 0.2s ease;\n    outline: none;\n}\n\n.modal-input:focus {\n    border-color: #f39c12;\n    background: #fff;\n    box-shadow: 0 0 0 4px rgba(243, 156, 18, 0.1);\n}\n\ntextarea.modal-input {\n    min-height: 100px;\n    resize: vertical;\n}\n\n.admin-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 16px;\n    margin-top: 40px;\n}\n\n.admin-modal-btn {\n    padding: 12px 24px;\n    border-radius: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    transition: all 0.2s ease;\n    font-size: 15px;\n}\n\n.admin-modal-btn:active {\n    transform: scale(0.98);\n}\n\n.admin-modal-btn.cancel {\n    background: #f1f5f9;\n    color: #64748b;\n}\n\n.admin-modal-btn.cancel:hover {\n    background: #e2e8f0;\n    color: #475569;\n}\n\n.admin-modal-btn.confirm {\n    background: linear-gradient(135deg, #f39c12 0%, #d35400 100%);\n    color: white;\n    box-shadow: 0 4px 6px -1px rgba(243, 156, 18, 0.2);\n}\n\n.admin-modal-btn.confirm:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 10px 15px -3px rgba(243, 156, 18, 0.3);\n}\n\n/* Mandate Modal */\n.mandate-modal {\n    max-width: 900px;\n    padding: 32px 36px;\n    max-height: 85vh;\n    overflow-y: auto;\n}\n\n.mandate-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid #f1f5f9;\n    padding-bottom: 16px;\n}\n\n.mandate-header h3 {\n    margin: 0;\n}\n\n.mandate-header p {\n    margin: 6px 0 0;\n    color: #64748b;\n    font-size: 0.9rem;\n}\n\n.mandate-section {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    padding: 18px 20px;\n    margin-bottom: 16px;\n}\n\n.mandate-status-bar {\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 12px 16px;\n    border-radius: 12px;\n    background: #fff7ed;\n    border: 1px solid #fed7aa;\n    color: #7c2d12;\n    margin-bottom: 16px;\n    font-weight: 600;\n}\n\n.mandate-details {\n    background: #0f172a;\n    color: #e2e8f0;\n    border-radius: 14px;\n    padding: 16px;\n    margin-bottom: 16px;\n    max-height: 240px;\n    overflow: auto;\n}\n\n.mandate-details h4 {\n    margin: 0 0 10px 0;\n    font-size: 0.9rem;\n    color: #f8fafc;\n}\n\n.mandate-details pre {\n    margin: 0;\n    white-space: pre-wrap;\n    word-break: break-word;\n    font-size: 0.8rem;\n}\n\n.mandate-section h4 {\n    margin: 0 0 12px 0;\n    font-size: 0.95rem;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    color: #475569;\n}\n\n.bank-filter-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.bank-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.85rem;\n    color: #475569;\n}\n\n.bank-select-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.mandate-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 14px 18px;\n}\n\n.mandate-modal .admin-form-group {\n    margin-bottom: 0;\n}\n\n.mandate-modal .admin-form-group label {\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #64748b;\n    font-weight: 600;\n    margin-bottom: 8px;\n}\n\n.mandate-modal .admin-form-input,\n.mandate-modal .admin-form-select {\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    background: #fff;\n    padding: 10px 12px;\n    font-size: 0.95rem;\n    width: 100%;\n}\n\n.mandate-modal .admin-form-input:focus,\n.mandate-modal .admin-form-select:focus {\n    outline: none;\n    border-color: #f39c12;\n    box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.15);\n}\n\n.mandate-message {\n    margin: 6px 0 0;\n    color: #065f46;\n    font-weight: 600;\n}\n\n.mandate-error-chip {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 8px;\n    padding: 4px 8px;\n    border-radius: 999px;\n    background: #fee2e2;\n    color: #991b1b;\n    font-size: 0.72rem;\n    font-weight: 700;\n    border: 1px solid #fecaca;\n}\n\n.mandate-error-panel {\n    background: #fee2e2;\n    color: #7f1d1d;\n    border: 1px solid #fecaca;\n    padding: 10px 12px;\n    border-radius: 12px;\n    margin-bottom: 16px;\n    font-weight: 600;\n}\n\n@media (max-width: 900px) {\n    .mandate-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .mandate-modal {\n        max-width: 640px;\n        padding: 24px;\n    }\n}\n\n.permissions-checklist::-webkit-scrollbar {\n    width: 6px;\n}\n\n.permissions-checklist::-webkit-scrollbar-track {\n    background: #f1f5f9;\n}\n\n.permissions-checklist::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 10px;\n}\n\n.permissions-checklist::-webkit-scrollbar-thumb:hover {\n    background: #94a3b8;\n}\n\n/* Delete Confirmation Modal Styles */\n.delete-confirmation-modal {\n    max-width: 500px !important;\n}\n\n.delete-modal-header {\n    text-align: center;\n    margin-bottom: 24px;\n    padding-bottom: 20px;\n    border-bottom: 2px solid #fee2e2;\n}\n\n.delete-modal-header .warning-icon {\n    font-size: 48px;\n    margin-bottom: 12px;\n    animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n\n    0%,\n    100% {\n        transform: scale(1);\n    }\n\n    50% {\n        transform: scale(1.1);\n    }\n}\n\n.delete-modal-header h3 {\n    color: #dc2626;\n    font-size: 22px;\n    font-weight: 700;\n    margin: 0;\n}\n\n.delete-modal-body {\n    margin-bottom: 24px;\n}\n\n.warning-text {\n    text-align: center;\n    font-size: 15px;\n    color: #374151;\n    margin-bottom: 24px;\n    line-height: 1.6;\n}\n\n.warning-text strong {\n    color: #dc2626;\n    font-weight: 700;\n}\n\n.loan-info-box {\n    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n    border-left: 4px solid #f59e0b;\n    padding: 16px 20px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n}\n\n.loan-info-box h4 {\n    margin: 0 0 12px 0;\n    color: #92400e;\n    font-size: 14px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.loan-info-box p {\n    margin: 6px 0;\n    color: #78350f;\n    font-size: 14px;\n}\n\n.loan-info-box strong {\n    color: #92400e;\n    font-weight: 600;\n}\n\n.warning-box {\n    background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n    border-left: 4px solid #dc2626;\n    padding: 16px 20px;\n    border-radius: 8px;\n}\n\n.warning-title {\n    margin: 0 0 12px 0;\n    color: #991b1b;\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.warning-list {\n    margin: 12px 0;\n    padding-left: 24px;\n    color: #7f1d1d;\n}\n\n.warning-list li {\n    margin: 6px 0;\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.danger-text {\n    margin: 12px 0 0 0;\n    color: #991b1b;\n    font-weight: 700;\n    font-size: 14px;\n    text-align: center;\n    padding-top: 12px;\n    border-top: 1px solid #fca5a5;\n}\n\n.admin-modal-btn.delete-confirm {\n    background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);\n    color: white;\n    box-shadow: 0 4px 6px -1px rgba(220, 38, 38, 0.3);\n    font-weight: 700;\n}\n\n.admin-modal-btn.delete-confirm:hover {\n    background: linear-gradient(135deg, #b91c1c 0%, #7f1d1d 100%);\n    transform: translateY(-1px);\n    box-shadow: 0 10px 15px -3px rgba(220, 38, 38, 0.4);\n}\n\n.admin-modal-btn.delete-confirm:active {\n    transform: scale(0.98);\n}\n\n\n\n\n.kanban-cards {\n    overflow-y: auto;\n    gap: 10px;\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 8px;\n    flex: 1;\n}\n\n.kanban-card {\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 12px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n    transition: transform 0.2s, box-shadow 0.2s;\n    cursor: grab;\n}\n\n.kanban-card:active {\n    cursor: grabbing;\n}\n\n.kanban-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n    border-color: #cbd5e1;\n}\n\n.k-card-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 8px;\n}\n\n.k-name {\n    font-weight: 600;\n    color: #0f172a;\n    font-size: 14px;\n}\n\n.k-date {\n    font-size: 10px;\n    color: #94a3b8;\n}\n\n.k-details {\n    font-size: 12px;\n    color: #64748b;\n    margin-bottom: 10px;\n    line-height: 1.5;\n}\n\n.k-source {\n    display: inline-block;\n    font-size: 10px;\n    background: #f1f5f9;\n    padding: 2px 6px;\n    border-radius: 4px;\n    color: #475569;\n}\n\n\n\n.leads-modal-header {\n    background: linear-gradient(to right, #f8fafc, #fff);\n    padding: 24px;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.leads-modal-header h3 {\n    margin: 0;\n    color: #0f172a;\n    font-size: 20px;\n    font-weight: 700;\n}\n\n.leads-modal-body {\n    padding: 24px;\n}\n\n.modal-grid-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.fancy-input-group {\n    position: relative;\n    margin-bottom: 6px;\n}\n\n.fancy-input,\n.fancy-select,\n.fancy-textarea {\n    width: 100%;\n    padding: 12px 14px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 14px;\n    transition: all 0.2s;\n    background: #ffffff;\n    box-sizing: border-box;\n    /* Important fix */\n}\n\n.fancy-input:focus,\n.fancy-select:focus,\n.fancy-textarea:focus {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    outline: none;\n}\n\n.fancy-label {\n    display: block;\n    margin-bottom: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #475569;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.modal-footer {\n    padding: 20px 24px;\n    background: #f8fafc;\n    border-top: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n}\n\n/* -----------------------------------------------------------------------------\n   LEADS DASHBOARD RESTRUCTURE - FINAL POLISH\n   ----------------------------------------------------------------------------- */\n\n/* Main Container */\n.leads-dashboard-container {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 80px);\n    /* Adjust based on your header height */\n    background: #f8fafc;\n    overflow: hidden;\n}\n\n/* 1. Header & Stats Section */\n.leads-header-section {\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    padding: 2px 0;\n    flex-shrink: 0;\n    padding: 2px 0;\n    flex-shrink: 0;\n    z-index: 20;\n    position: relative;\n}\n\n.leads-insights-row {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    padding: 16px 24px;\n    max-width: 1600px;\n    margin: 0 auto;\n}\n\n.mini-kpi {\n    background: #ffffff;\n    border: 1px solid #f1f5f9;\n    border-radius: 10px;\n    padding: 16px 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n    position: relative;\n    overflow: hidden;\n    min-height: 120px;\n    padding: 20px;\n}\n\n.kpi-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.kpi-header span:first-child {\n    font-size: 13px;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.kpi-trend {\n    font-size: 12px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 12px;\n    background: #f1f5f9;\n    color: #64748b;\n}\n\n.kpi-trend.up {\n    background: #dcfce7;\n    color: #16a34a;\n}\n\n.kpi-alert {\n    font-size: 11px;\n    font-weight: 700;\n    color: #ef4444;\n    background: #fee2e2;\n    padding: 2px 6px;\n    border-radius: 4px;\n}\n\n.kpi-body {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n}\n\n.kpi-body strong {\n    font-size: 28px;\n    font-weight: 700;\n    color: #1e293b;\n    line-height: 1;\n}\n\n.kpi-chart {\n    flex-grow: 1;\n    max-width: 100px;\n    height: 40px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n.kpi-chart.donut svg {\n    transform: rotate(-90deg);\n}\n\n.kpi-chart.bars {\n    display: flex;\n    gap: 4px;\n    align-items: flex-end;\n    height: 32px;\n}\n\n.kpi-chart.bars .bar {\n    width: 6px;\n    background: #e2e8f0;\n    border-radius: 2px;\n    transition: height 0.3s ease;\n}\n\n.kpi-chart.bars .bar.active {\n    background: #10b981;\n}\n\n.kpi-icon-bg {\n    color: #f59e0b;\n    opacity: 0.8;\n}\n\n.mini-kpi::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 3px;\n    height: 100%;\n}\n\n.mini-kpi.purple::after {\n    background: #8b5cf6;\n}\n\n.mini-kpi.blue::after {\n    background: #3b82f6;\n}\n\n.mini-kpi.green::after {\n    background: #10b981;\n}\n\n.mini-kpi.amber::after {\n    background: #f59e0b;\n}\n\n.mini-kpi span {\n    font-size: 11px;\n    font-weight: 700;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    margin-bottom: 6px;\n}\n\n.mini-kpi strong {\n    font-size: 28px;\n    font-weight: 800;\n    color: #1e293b;\n    line-height: 1.1;\n}\n\n/* 2. Controls Toolbar */\n.leads-toolbar {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    gap: 20px;\n    align-items: center;\n    padding: 12px 24px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    position: relative;\n    z-index: 15;\n}\n\nbutton {\n    cursor: pointer;\n}\n\n.search-stack {\n    flex: 1;\n    max-width: 400px;\n    position: relative;\n}\n\n.search-input {\n    width: 100%;\n    padding: 0 16px 0 36px;\n    height: 40px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background: #f8fafc;\n    font-size: 14px;\n    transition: all 0.2s;\n}\n\n.search-input:focus {\n    background: #fff;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.search-icon-placeholder {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #94a3b8;\n    pointer-events: none;\n}\n\n.filter-group {\n    display: flex;\n    gap: 10px;\n}\n\n.filter-select {\n    height: 40px;\n    padding: 0 32px 0 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background-color: #ffffff;\n    font-size: 13px;\n    color: #334155;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.filter-select:hover {\n    border-color: #cbd5e1;\n}\n\n.view-toggle-group {\n    display: flex;\n    background: #f1f5f9;\n    padding: 3px;\n    border-radius: 8px;\n}\n\n.view-btn {\n    padding: 6px 12px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #64748b;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    border-radius: 6px;\n}\n\n.view-btn.active {\n    background: #fff;\n    color: #0f172a;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n/* 3. Quick Pills Row */\n.pill-filters {\n    display: flex;\n    gap: 8px;\n    padding: 12px 24px;\n    background: #fff;\n    border-bottom: 1px solid #e2e8f0;\n    overflow-x: auto;\n    flex-shrink: 0;\n    /* Prevent shrinking */\n}\n\n.pill {\n    padding: 6px 14px;\n    border-radius: 99px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #475569;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    cursor: pointer;\n    transition: all 0.15s;\n    white-space: nowrap;\n}\n\n.pill:hover {\n    background: #f1f5f9;\n    color: #1e293b;\n}\n\n.pill.active {\n    background: #eff6ff;\n    color: #2563eb;\n    border-color: #bfdbfe;\n}\n\n/* 4. Kanban Board Area */\n.kanban-board-container {\n    flex: 1;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding: 24px;\n    background: #f8fafc;\n}\n\n.kanban-board {\n    display: flex;\n    gap: 20px;\n    height: 100%;\n    align-items: flex-start;\n}\n\n.kanban-column {\n    min-width: 280px;\n    width: 280px;\n    max-width: 280px;\n    background: #eff1f5;\n    /* Subtle contrast */\n    border-radius: 12px;\n    padding: 6px;\n    /* Tighter padding */\n    display: flex;\n    flex-direction: column;\n    max-height: 100%;\n    border: 1px solid #e2e8f0;\n}\n\n.kanban-header {\n    padding: 12px 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 13px;\n    font-weight: 700;\n    color: #475569;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.kanban-count {\n    background: rgba(0, 0, 0, 0.05);\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 11px;\n    color: #64748b;\n}\n\n.kanban-cards {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0 4px 4px 4px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n/* Custom Scrollbar for columns */\n.kanban-cards::-webkit-scrollbar {\n    width: 4px;\n}\n\n.kanban-cards::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 4px;\n}\n\n.kanban-card {\n    background: #fff;\n    border-radius: 8px;\n    padding: 14px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n    border: 1px solid transparent;\n    transition: all 0.2s;\n    cursor: grab;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.kanban-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.08);\n    /* Better lift */\n    border-color: #cbd5e1;\n    z-index: 5;\n}\n\n.k-card-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.k-name {\n    font-size: 14px;\n    font-weight: 700;\n    color: #1e293b;\n    line-height: 1.3;\n}\n\n.k-date {\n    font-size: 11px;\n    color: #94a3b8;\n    font-weight: 500;\n}\n\n.k-source {\n    align-self: flex-start;\n    font-size: 10px;\n    font-weight: 600;\n    color: #64748b;\n    background: #f1f5f9;\n    padding: 3px 8px;\n    border-radius: 4px;\n    border: 1px solid #e2e8f0;\n}\n\n.k-details {\n    font-size: 12px;\n    color: #475569;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.k-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 10px;\n    border-top: 1px solid #f1f5f9;\n    margin-top: 2px;\n}\n\n.k-assignee {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n    font-weight: 500;\n    color: #64748b;\n}\n\n.icon-btn {\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    border: 1px solid transparent;\n    background: transparent;\n    color: #94a3b8;\n    transition: all 0.15s;\n    cursor: pointer;\n}\n\n.icon-btn:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n}\n\n.icon-btn.whatsapp:hover {\n    color: #16a34a;\n    background: #dcfce7;\n}\n\n.icon-btn.call:hover {\n    color: #0284c7;\n    background: #e0f2fe;\n}\n\n.icon-btn.edit:hover {\n    color: #f59e0b;\n    background: #fef3c7;\n}\n\n.icon-btn.assign:hover {\n    color: #6366f1;\n    background: #e0e7ff;\n}\n\n.icon-btn.delete:hover {\n    color: #ef4444;\n    background: #fee2e2;\n}\n\n/* 5. Modal Polish */\n.leads-modal-header {\n    background: #ffffff;\n    padding: 20px 24px;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.leads-modal-header h3 {\n    font-size: 18px;\n    font-weight: 700;\n    color: #0f172a;\n}\n\n.leads-modal-body {\n    padding: 24px;\n    background: #fcfcfc;\n}\n\n.modal-grid-row {\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.fancy-label {\n    font-size: 11px;\n    font-weight: 700;\n    color: #64748b;\n    margin-bottom: 6px;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n}\n\n.fancy-input,\n.fancy-select,\n.fancy-textarea {\n    border: 1px solid #e2e8f0;\n    background: #fff;\n    border-radius: 8px;\n    padding: 10px 12px;\n    font-size: 14px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);\n}\n\n.fancy-input:focus,\n.fancy-select:focus,\n.fancy-textarea:focus {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    outline: none;\n}\n\n.modal-footer {\n    padding: 20px 24px;\n    background: #a85757;\n    border-top: 1px solid #f1f5f9;\n}\n\n/* -----------------------------------------------------------------------------\n   LEADS MODAL OVERLAY STYLES\n   ----------------------------------------------------------------------------- */\n\n.leads-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(15, 23, 42, 0.6);\n    backdrop-filter: blur(4px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n.leads-modal-content {\n    background: #ffffff;\n    border-radius: 12px;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    width: 100%;\n    max-width: 600px;\n    max-height: 90vh;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    animation: modalSlideUp 0.3s ease-out forwards;\n}\n\n@keyframes modalSlideUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
